/**
 * Agrupa los datos por un campo y calcula TVP:
 * T = Total de incidentes
 * V = Velocidad máxima registrada
 * P = Promedio de velocidad
 *
 * @param {Array} datos - Array de registros de excesos
 * @param {string} campoClave - Nombre del campo por el que agrupar (ej: 'OPERADOR', 'CLIENTE')
 * @returns {Array} Array ordenado por total desc con { nombre, total, velocidadMax, promedio }
 */
export const calcularTVP = (datos, campoClave) => {
    const mapa = {};

    datos.forEach((row) => {
        const clave = (row[campoClave] ?? 'N/A').toString().trim();
        if (!mapa[clave]) {
            mapa[clave] = { nombre: clave, total: 0, velocidadMax: 0, sumaVel: 0 };
        }
        mapa[clave].total += 1;
        mapa[clave].sumaVel += row.VELOCIDAD ?? 0;
        if ((row.VELOCIDAD ?? 0) > mapa[clave].velocidadMax) {
            mapa[clave].velocidadMax = row.VELOCIDAD ?? 0;
        }
    });

    return Object.values(mapa)
        .map((e) => ({
            nombre: e.nombre,
            total: e.total,
            velocidadMax: e.velocidadMax,
            promedio: e.total > 0 ? Math.floor(e.sumaVel / e.total) : 0,
        }))
        .sort((a, b) => b.total - a.total);
};
